export default "__VITE_ASSET__79635355__"